import { createSlice } from '@reduxjs/toolkit';
import { getStorage, setStorage } from './utils/storage'; // Pastikan path benar

const defaultState = {
  theme: 'light',
  menu: 'horizontal',
  layout: 'full',
  rtlClass: 'ltr',
  animation: '',
  navbar: 'navbar-sticky',
  sidebar: false,
  pageTitle: '',
  semidark: false,
};

const initialState = {
  theme: getStorage('theme', defaultState.theme),
  menu: getStorage('menu', defaultState.menu),
  layout: getStorage('layout', defaultState.layout),
  rtlClass: getStorage('rtlClass', defaultState.rtlClass),
  animation: getStorage('animation', defaultState.animation),
  navbar: getStorage('navbar', defaultState.navbar),
  sidebar: getStorage('sidebar', defaultState.sidebar) === 'true', // Pastikan boolean
  semidark: getStorage('semidark', defaultState.semidark) === 'true', // Pastikan boolean
};

const themeConfigSlice = createSlice({
  name: 'themeConfig',
  initialState,
  reducers: {
    toggleTheme(state, { payload }) {
      state.theme = payload || state.theme;
      setStorage('theme', state.theme);
      document.querySelector('body')?.classList.toggle('dark', state.theme === 'dark');
    },
    toggleAnimation(state, { payload }) {
      state.animation = payload || '';
      setStorage('animation', state.animation);
    },
    toggleMenu(state, { payload }) {
      state.menu = payload || state.menu;
      setStorage('menu', state.menu);
    },
    toggleLayout(state, { payload }) {
      state.layout = payload || state.layout;
      setStorage('layout', state.layout);
    },
    toggleRTL(state, { payload }) {
      state.rtlClass = payload || state.rtlClass;
      setStorage('rtlClass', state.rtlClass);
      document.querySelector('html')?.setAttribute('dir', state.rtlClass);
    },
    toggleNavbar(state, { payload }) {
      state.navbar = payload || state.navbar;
      setStorage('navbar', state.navbar);
    },
    toggleSemidark(state, { payload }) {
      state.semidark = payload === true || payload === 'true';
      setStorage('semidark', state.semidark);
    },
    toggleSidebar(state) {
      state.sidebar = !state.sidebar;
      setStorage('sidebar', state.sidebar);
    },
    setPageTitle(state, { payload }) {
      document.title = `${payload} | Pain-Management`;
    },
  },
});

export const {
  toggleTheme,
  toggleAnimation,
  toggleMenu,
  toggleLayout,
  toggleRTL,
  toggleNavbar,
  toggleSemidark,
  toggleSidebar,
  setPageTitle,
} = themeConfigSlice.actions;

export default themeConfigSlice.reducer;
